import { render } from "./ImsData.vue?vue&type=template&id=d7681c68&scoped=true"
import script from "./ImsData.vue?vue&type=script&lang=js"
export * from "./ImsData.vue?vue&type=script&lang=js"

import "./ImsData.vue?vue&type=style&index=0&id=d7681c68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d7681c68"

export default script